module.exports = __webpack_public_path__ + "img/seo_gchess_item01.bef0c37.webp";